import { render, staticRenderFns } from "./PostagensHome.vue?vue&type=template&id=405f2ba8&scoped=true"
import script from "./PostagensHome.vue?vue&type=script&lang=js"
export * from "./PostagensHome.vue?vue&type=script&lang=js"
import style0 from "./PostagensHome.vue?vue&type=style&index=0&id=405f2ba8&prod&lang=scss&scoped=true"
import style1 from "./PostagensHome.vue?vue&type=style&index=1&id=405f2ba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405f2ba8",
  null
  
)

export default component.exports